export default __webpack_public_path__ + "static/media/img_top_5.c7cec1fc.webp";